import React from "react";
import {FieldTableCellProps, getTableCellStyle} from "../../../../render/table/table-cell";
import FieldText_Popover from "../../components/popover/popover";
import {isBulkSelection} from "../../../../../gd/right-click-menu";

type State = {
    isHovered   : boolean
    showPopover : boolean
}

export default class FieldText_TableCell extends React.Component<FieldTableCellProps, State>{

    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            isHovered   : false,
            showPopover : false
        }
    }

    get isEditable():boolean {
        return !this.props.manager.isReadOnly && this.props.field.canEdit(this.props.listItem.task)
    }

    onMouseEnter = () => {
        if (!this.isEditable) return
        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.showPopover) return //
        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    onValueSave = (value:number|null, hidePopover:boolean=true) => {

       this.props.listItem.task.setCustomFieldValue(this.props.field.fieldId, value)

        this.props.listItem.task.save()
        this.props.listItem.task.setCustomFieldValue(this.props.field.fieldId, value)
        this.props.listItem.task.save()

        hidePopover && this.hidePopover()
    }
    onDeleteClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) return
        e.stopPropagation()
        this.onValueSave(null, false)
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.isEditable) return

        this.setState({
            showPopover     : !this.state.showPopover
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    get style() {
        return getTableCellStyle(this.props)
    }

    // getFieldViewData = ()=>{
    //     return this.props.listItem.item.customFieldsData[this.props.field.fieldId]
    // }

    renderHovered() {

        const classes = Classes("cell-flex ui5-txt-less-important-small p-0", this.props.column.id)

        // const value = this.getFieldViewData()
        const value = this.props.field.getViewValue(this.props.listItem.item)

        return (
            <div className={classes} style={this.style} onMouseLeave={this.onMouseLeave} >
                <div className="ui5-field-editable is-hovered w-100-percent h-100-percent p-l-5" onClick={this.onClick}>

                    {!!value && <div className="txt-truncate">{value}</div>}

                    <div className="buttons p-r-8">
                        {!!value && !this.state.showPopover && <div className="btn-reset" onClick={this.onDeleteClick}/>}
                    </div>

                    {this.state.showPopover &&
                        <FieldText_Popover field={this.props.field}
                                           parent={this}
                                           value={value}
                                           onSave={this.onValueSave}/>}
                </div>
            </div>
        )
    }

    renderNotHovered() {

        const classes = Classes("cell-flex ui5-txt-less-important-small p-l-6")
        // const value = this.getFieldViewData()
        const value = this.props.field.getViewValue(this.props.listItem.item)


        return (
            <div className={classes} style={this.style} onMouseEnter={this.onMouseEnter}>
                {!! value && <div className="txt-truncate">{value}</div>}
            </div>
        )
    }

    render() {
        if (this.state.isHovered) return this.renderHovered()
        else return this.renderNotHovered()
    }
}
